<style >
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
/* 修改 */
.config-box {
  /* display: flex; */
  margin: 10px 0;
  background: #fff;
  text-align: left;
  padding: 20px;
  border-radius: 6px;
}
.config-title {
  font-weight: 700;
  /* margin-bottom: 20px; */
}
.add-platform {
  position: relative;
  color: #4fa1a4;
  min-width: 120px;
  height: 64px;
  line-height: 64px;
  text-align: center;
  border: 1px solid rgba(235, 235, 235, 1);
  border-radius: 4px;
  margin-top: 20px;
  cursor: pointer;
  padding: 0 10px;
}
.add-platform img {
  position: absolute;
  right: -5px;
  bottom: 4px;
  width: 18px;
}
.platform-name {
  /* text-align: left; */
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-icon-plus {
  color: #4fa1a4!important;
}
.config-list {
  margin-right: 20px;
}
.config-btn {
  display: inline-block;
  width: 45%;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  text-align: center;
  /* margin-right: 10px; */
  margin-top: 10px;
  border-radius: 4px;
  cursor: pointer;
}
.config-edit {
  float: left;
  color: #1890ff;
  border: 1px solid #1890ff;
  /* margin-right: 2%; */
}
.config-del {
  float: right;
  color: red;
  border: 1px solid red;
}
.config-content {
  display: flex;
  flex-wrap: wrap;
  padding-left: 15px;
}
.appSide-ruleForm {
  padding-right: 20px;
}
/* .demo-ruleForm .el-upload--picture-card{
  width: 100px;
  height: 100px;
  line-height: 100px;
} */
.table-sty {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.menu-tree {
  width: 18% !important;
  margin-right: 1%;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 4px;
}
/* 菜单树过长时内部滚动，搜索框保持可见 */
.menu-tree .el-tree {
  max-height: 750px;
  overflow-y: auto;
}
.menu-right {
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 4px;
}
/* 表格纵向滚动走 el-table 的 max-height 属性；这里只把横向滚动条加粗便于拖动（全局样式仅5px） */
.menu-right .el-table .el-table__body-wrapper::-webkit-scrollbar {
  height: 10px;
}
.el-tabs__header {
  padding-left: 20px;
}
.icon-dialog {
  display: flex;
  overflow: hidden;
}
.icon-dialog .icon-left {
  width: 130px;
  text-align: left;
  border-right: 1px solid #cccc;
}
.icon-left .item {
  height: 40px;
  line-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 20px;
}
.icon-dialog .icon-right {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  height: auto;
  padding-left: 10px;
}
.icon-right .pic {
  width: 100px;
  height: 130px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.icon-right .pic .img {
  width: 100px;
  height: 100px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.06);
}
.icon-right .pic .img:hover {
  border: 1px solid #4fa1a4;
  border-radius: 4px;
}
.img-wrap {
  position: relative;
}
.img-wrap .border-img {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 0;
  top: 0;
}
.img-wrap .name {
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.file-img {
  width: 100%;
  height: 100%;
}
.icon-add {
  float: left;
  margin-left: 10px;
  width: 150px;
  height: 150px;
  border: 1px dotted #ccc;
  text-align: center;
  line-height: 150px;
}
.img-close {
  position: relative;
  float: left;
  width: 150px;
  height: 150px;
  margin-left: 20px;
}
.close {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
}
.icon-dialog-wrap .el-dialog__body {
  padding: 0;
  padding-top: 10px;
}
</style>


<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- 配置平台  -->
    <div class="config-box">
      <div class="config-title"><img src="../assets/images/bottom.png" alt="" /> 配置平台</div>
      <div class="config-content">
        <div class="config-list" v-for="(item, index) in platformList" :key="index">
          <div class="add-platform" @click="platformSelect(item, index)">
            <span>{{ item.platformName }}</span>
            <img v-if="selectPlatformIndex == index" src="../assets/images/choose.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="设置平台多端" name="first"> -->
        <!-- 配置应用端  -->
        <div class="config-box">
          <div class="config-title"><img src="../assets/images/bottom.png" alt="" /> 配置应用端</div>
          <div class="config-content">
            <div class="add-platform cursor-sty mr20" @click="addAppSide()">
              <i class="el-icon-plus"> 添加应用端</i>
            </div>
            <div class="config-list" v-for="(item, index) in appSideList" :key="index">
              <div class="add-platform" @click="appSideSelect(item, index)">
                <span>{{ item.appSideName }}</span>
                <img v-if="selectAppSideIndex == index" src="../assets/images/choose.png" alt="" />
              </div>
              <span class="config-edit config-btn" @click="addAppSide(1, item, index)">编辑</span>
              <span class="config-del config-btn" @click="delAppSide(item.guid)">删除</span>
            </div>
          </div>
        </div>
      <!-- </el-tab-pane> -->
      <!-- <el-tab-pane label="设置平台应用产品集" name="second"> -->
        <!-- 配置应用产品  -->
        <div class="config-box">
          <div class="config-title"><img src="../assets/images/bottom.png" alt="" /> 配置应用产品</div>
          <div class="config-content">
            <div class="add-platform cursor-sty mr20" @click="addProducts()">
              <i class="el-icon-plus"> 添加应用产品</i>
            </div>
            <div class="config-list" v-for="(item, index) in productList" :key="index">
              <div class="add-platform" @click="productSelect(item, index)">
                <span>{{ item.productName }}</span>
                <img v-if="selectProductIndex == index" src="../assets/images/choose.png" alt="" />
              </div>
              <span class="config-edit config-btn" @click="addProducts(1, item, index)">编辑</span>
              <span class="config-del config-btn" @click="delProduct(item.guid)">删除</span>
            </div>
          </div>
        </div>
        <!-- 配置菜单  -->
        <div class="config-box">
          <div class="config-title"><img src="../assets/images/bottom.png" alt="" /> 配置菜单</div>
          <div class="back-color-fff table-sty" style="padding: 16px; display: flex">
            <div class="menu-tree w21f">
              <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
              <el-tree
                class="filter-tree"
                :data="menuList"
                :props="defaultProps"
                default-expand-all
                :filter-node-method="filterNode"
                @node-click="handleNodeCilck"
                :highlight-current="showTree"
                node-key="guid"
                ref="tree"
              >
              </el-tree>
            </div>
            <div class="menu-right w100f">
              <el-row :gutter="20">
                <el-col :span="5"><el-button size="medium" type="info" @click="add(1)">+ 新增菜单</el-button></el-col>
              </el-row>
              <el-table
                :data="menuListTable"
                style="width: 100%; margin-bottom: 20px; margin-top: 20px"
                border
                max-height="700"
                v-loading="loading"
              >
                <el-table-column prop="menuName" label="名称" header-align="center" align="left"> </el-table-column>
                <el-table-column prop="orderNum" label="排序" header-align="center" align="center"> </el-table-column>
                <el-table-column prop="path" label="H5/Web路径" header-align="center" align="left"> </el-table-column>
                <el-table-column prop="appletPath" label="小程序路径" header-align="center" align="left"> </el-table-column>
                <el-table-column prop="bizState" label="应用状态" header-align="center" align="left">
                  <template slot-scope="scope">{{ scope.row.bizState | getBizState }}</template>
                </el-table-column>
                <el-table-column prop="visible" label="显示状态" header-align="center" align="left">
                  <template slot-scope="scope">{{ scope.row.visible | getVisible }}</template>
                </el-table-column>
                <el-table-column prop="menuType" label="类型" header-align="center" align="left">
                  <template slot-scope="scope">{{ scope.row.menuType | getMenuType }}</template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" sortable header-align="center" align="left">
                  <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
                </el-table-column>
                <el-table-column prop="updateTime" label="上次更新时间" sortable header-align="center" align="left">
                  <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
                </el-table-column>
                <el-table-column label="操作" header-align="center" align="center" width="180">
                  <template slot-scope="scope">
                    <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
                    <a class="txt-color" @click="add(3, scope.row)">添加子菜单 | </a>
                    <a class="txt-color-red" @click="getDeleteData(scope.row.guid)">删除</a>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      <!-- </el-tab-pane>
    </el-tabs> -->

    <!-- 添加平台弹框 -->
    <el-dialog :close-on-click-modal="false" :title="titlePlatform" :visible.sync="dialogPlatform" width="550px">
      <div class="platform-name">
        <label>平台名称：</label><el-input v-model="platformName" class="ipt-sty" placeholder="请输入"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogPlatform = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitPlatform()">确定</el-button>
      </div>
    </el-dialog>

    <!-- 添加应用弹框 -->
    <el-dialog :close-on-click-modal="false" :title="titleAppSide" :visible.sync="dialogAppSide" width="550px">
      <el-form ref="appSideRuleForm" label-width="100px" :label-position="right" class="appSide-ruleForm">
        <el-form-item label="应用端:" required>
          <el-input v-model="appSide.appSideName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="标识符:">
          <el-input v-model="appSide.identifier" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="应用形式:" required class="t-left">
          <el-radio-group v-model="appSide.appType">
            <el-radio label="01">PC</el-radio>
            <el-radio label="02">微信</el-radio>
            <el-radio label="03">APP</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="dialogAppSide = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitAppSide()">确定</el-button>
      </div>
    </el-dialog>

    <!-- 添加应用产品弹框 -->
    <div v-show="!iconVisible">
      <el-dialog :close-on-click-modal="false" :title="titleProduct" :visible.sync="dialogProduct" width="550px">
        <el-form ref="productForm" label-width="110px" :label-position="right" class="appSide-ruleForm">
          <el-form-item label="应用产品:" required>
            <el-input v-model="product.productName" placeholder="请输入应用产品名称" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="产品路由:">
            <el-input v-model="product.productRoute" placeholder="请输入产品路由" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="应用简述:">
            <el-input
              v-model="product.productDesc"
              placeholder="请输入应用简述"
              autocomplete="off"
              maxlength="500"
              type="textarea"
              rows="3"
            ></el-input>
          </el-form-item>
          <el-form-item label="排序:">
            <el-input
              v-model.number="product.orderNum"
              placeholder="请输入应用排序"
              autocomplete="off"
              max="999999"
            ></el-input>
          </el-form-item>
          <el-form-item label="应用图标:">
            <div class="img-close" v-if="fileListIcon && fileListIcon.length != 0 && fileListIcon[0].url">
              <img
                class="file-img"
                :src="fileListIcon && fileListIcon.length != 0 && fileListIcon[0].url"
                alt=""
                srcset=""
              />
              <img class="close" @click="delPic(0)" src="@/assets/images/ic_close.png" alt="" />
            </div>
            <div class="icon-add" @click="addPic(0)"><i class="el-icon-plus"></i></div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="dialogProduct = false">取消</el-button>
          <el-button size="medium" type="info" @click="submitProduct()">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 菜单弹框 -->
    <div v-show="!iconVisible">
      <el-dialog :close-on-click-modal="false" :title="textTitle" :visible.sync="dialogFormVisible" width="650px">
        <el-form :model="ruleForm" label-width="112px" :label-position="right" class="demo-ruleForm">
          <el-form-item label="上级:">
            <el-cascader
              :disabled="textTitle == '添加子菜单' ? true : false"
              class="w100f"
              placeholder="请选择"
              v-model="ruleForm.parentGuid"
              :options="menuList"
              :show-all-levels="false"
              clearable
              :props="{ value: 'guid', label: 'menuName', children: 'children', checkStrictly: true }"
              filterable
              @change="parentChange"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="类型:" prop="menuType" class="t-left" required>
            <el-radio-group v-model="ruleForm.menuType">
              <el-radio label="M">目录</el-radio>
              <el-radio label="C">菜单</el-radio>
              <el-radio label="P">页面</el-radio>
              <el-radio label="F">按钮</el-radio>
              <el-radio label="I">接口</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="图标:">
            <div class="img-close" v-if="fileList && fileList.length != 0 && fileList[0].url">
              <img class="file-img" :src="fileList && fileList.length != 0 && fileList[0].url" alt="" srcset="" />
              <img class="close" @click="delPic(1)" src="@/assets/images/ic_close.png" alt="" />
            </div>
            <div class="icon-add" @click="addPic(1)"><i class="el-icon-plus"></i></div>
            <!-- <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl1" alt="" />
            </el-dialog>
            <el-upload
              action="#"
              name="image"
              class="fl ml10"
              list-type="picture-card"
              :headers="token"
              :file-list="fileList"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :http-request="uploadImage"
            >
              <div slot="image" slot-scope="{ file }">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                    <i class="el-icon-download"></i>
                  </span>
                  <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
              <i slot="default" class="el-icon-plus"></i>
            </el-upload> -->
          </el-form-item>
          <el-form-item label="名称:" required>
            <el-input v-model="ruleForm.menuName" placeholder="请输入" autocomplete="off" class="w100f"></el-input>
          </el-form-item>
          <el-form-item label="顺序:" required>
            <el-input v-model="ruleForm.orderNum" placeholder="请输入" autocomplete="off" class="w100f"></el-input>
          </el-form-item>
          <el-form-item label="H5/Web路径:">
            <el-input v-model="ruleForm.path" placeholder="请输入" autocomplete="off" class="w100f"></el-input>
          </el-form-item>
          <el-form-item label="小程序路径:">
            <el-input v-model="ruleForm.appletPath" placeholder="请输入" autocomplete="off" class="w100f"></el-input>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input
              v-model="ruleForm.remark"
              placeholder="请输入，最多10个字"
              max="10"
              autocomplete="off"
              class="w100f"
            ></el-input>
          </el-form-item>
          <el-form-item label="消息组:" v-if="ruleForm.menuType == 'I'">
            <el-select v-model="ruleForm.messageGroupGuid" placeholder="请选择" class="w100f" filterable>
              <el-option v-for="item in msgList" :key="item.guid" :label="item.groupName" :value="item.guid">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否新开窗口:" class="t-left" required>
            <el-radio v-model="ruleForm.isNewWindow" label="N">否</el-radio>
            <el-radio v-model="ruleForm.isNewWindow" label="Y">是</el-radio>
          </el-form-item>
          <el-form-item label="外链:" class="t-left" required>
            <el-radio v-model="ruleForm.isExternalLink" label="N">否</el-radio>
            <el-radio v-model="ruleForm.isExternalLink" label="Y">是</el-radio>
          </el-form-item>
          <el-form-item label="应用状态:" class="t-left" required>
            <el-radio v-model="ruleForm.bizState" label="Y">有效</el-radio>
            <el-radio v-model="ruleForm.bizState" label="S">停用</el-radio>
          </el-form-item>
          <el-form-item label="显示状态:" class="t-left" required>
            <el-radio v-model="ruleForm.visible" label="Y">可见</el-radio>
            <el-radio v-model="ruleForm.visible" label="N">隐藏</el-radio>
          </el-form-item>
          <el-form-item label="外链标识:" class="t-left">
            <el-radio v-model="ruleForm.externalLinkMark" label="01">是</el-radio>
            <el-radio v-model="ruleForm.externalLinkMark" label="">否</el-radio>
          </el-form-item>
          <el-form-item label="是否首页:" class="t-left">
            <el-radio v-model="ruleForm.isHome" label="Y">是</el-radio>
            <el-radio v-model="ruleForm.isHome" label="N">否</el-radio>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="medium" type="info" v-if="textTitle == '新增'" @click="submitForm('ruleForm')"
            >确定</el-button
          >
          <el-button size="medium" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button>
        </div>
      </el-dialog>
    </div>

    <el-dialog :close-on-click-modal="false" title="任务图标选择" class="icon-dialog-wrap" :visible.sync="iconVisible" width="50%">
      <div class="icon-dialog">
        <div class="icon-left">
          <div
            class="item"
            :style="activeIcon == index ? 'background:#EDEDED;' : ''"
            @click="handleClickMenu(index)"
            v-for="(item, index) in iconList"
            :key="index"
          >
            <el-tooltip :content="item.paramName" placement="top">
              <span>
                {{ item.paramName }}
              </span>
            </el-tooltip>
          </div>
        </div>
        <div class="icon-right">
          <div
            class="pic"
            v-for="(item, index) in iconList[activeIcon] &&
            iconList[activeIcon].paramValue &&
            JSON.parse(iconList[activeIcon].paramValue)"
            :key="index"
          >
            <div class="img-wrap" @click="chooseIcon(item.url)">
              <el-image class="img" :src="item.url" fit="contain" />
              <div class="name">{{ item.name }}</div>
              <img
                :style="chooseURL == item.url ? 'display:block' : 'display:none;'"
                class="border-img"
                src="@/assets/images/ic_select.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="info" @click="moreSureIcon">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      url: `${route}/ms-common-admin-cloud-service/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      activeNames: ['1', '2', '3'],
      appsideList: [],
      appSideGuid: '',
      platformGuid: '',
      productGuid: '',
      tableData: [],
      appsideSh: true,
      appsides: '',
      products: '',
      productSh: true,
      menuList: [],
      menuName: '',
      menuType: '',
      dialogFormVisible: false,
      textTitle: '',
      ruleForm: {
        guid: '',
        parentGuid: '',
        parentName: '',
        menuName: '',
        menuType: 'C',
        orderNum: '',
        path: '',
        appletPath:'',
        icon: '',
        isExternalLink: 'N',
        bizState: 'Y',
        visible: 'Y',
        externalLinkMark: '',
        platformGuid: '',
        productGuid: '',
        appSideGuid: '',
        remark: '',
        messageGroupGuid: '',
        isHome: 'N',
        isNewWindow: 'N',
      },
      fileList: [],
      dialogImageUrl1: '',
      dialogVisible: false,
      //应用产品图标上传
      dialogVisibleIcon: false,
      dialogImageIcon: '',
      fileListIcon: [],
      //应用产品背景图上传
      dialogVisibleBack: false,
      dialogImageBack: '',
      fileListBack: [],

      disabled: false,
      right: '',
      page: {
        pageIndex: 1,
        pageSize: 10,
        guid: '',
        platformName: '',
        startTime: '',
        endTime: '',
      },
      loading: false,
      fullscreenLoading: false,
      //修改 平台
      titlePlatform: '新增',
      dialogPlatform: false,
      platformName: '',
      platformList: [],
      selectPlatformIndex: 0,
      //应用端
      dialogAppSide: false,
      titleAppSide: '添加',
      appSide: {
        appSideName: '',
        identifier: '',
        appType: '01',
        platformGuid: '',
        guid: '',
        unifiedLoginAuthUrl: '',
      },
      appSideList: [],
      selectAppSideIndex: 0,
      //应用产品
      dialogProduct: false,
      titleProduct: '添加',
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'menuName',
      },
      product: {
        guid: '',
        productGuid: '',
        productName: '',
        productRoute: '',
        productDesc: '',
        icon: '',
        orderNum: null,
        mananger: '',
        manangerContactTel: '',
        operationParty: '',
        operationContacts: '',
        operationContactTel: '',
        upTime: '',
        platformGuid: '',
      },
      productList: [],
      // productLists:[{name:"报货"}],
      selectProductIndex: 0,
      menuListTable: [],
      menuParentGuid: '',
      showTree: true,
      msgList: [],
      activeName: 'first',

      iconVisible: false,
      iconList: [],
      activeIcon: 0,
      chooseURL: null,
      type: 0,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.getPlatformList();
    this.getMsgData();
    this.getIconList();
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.menuName.indexOf(value) !== -1;
    },
    /******************************* 平台 ************************************/
    getPlatformList() {
      let self = this;
      let promise = {
        pageIndex: 1,
        pageSize: -1,
      };
      self.fullscreenLoading = true;
      self.api.postJson('/ms-common-admin-cloud-service/platform/data/get', promise).then((res) => {
        if (res.data.code == '00000') {
          self.fullscreenLoading = false;
          self.platformList = res.data.data.records;
          self.platformGuid = res.data.data.records[this.selectPlatformIndex].guid;
          Promise.all([self.getAppsideData(self.platformGuid), self.getAllProduct(self.platformGuid)]).then((res) => {
            self.getMenuListNoParent();
          });
          // self.getAllProduct(self.appsideList[0]);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //选中 平台
    platformSelect(item, index) {
      this.selectPlatformIndex = index;
      this.platformGuid = item.guid;
      this.getPlatformList();
    },
    /******************************* 应用端 ************************************/
    //获取应用端数据
    getAppsideData(platformGuid) {
      let self = this;
      self.fullscreenLoading = true;
      // let platformGuid = JSON.parse(localStorage.getItem("platformGuid"));
      let promise = {
        guid: '',
        pageIndex: 1,
        appSideName: '',
        pageSize: -1,
        platformGuid: self.platformGuid,
        startTime: '',
        endTime: '',
      };
      return new Promise((resolve, reject) => {
        self.api.postJson('/ms-common-admin-platform-auth-service/appside/data/get', promise).then((res) => {
          if (res.data.code == '00000') {
            self.fullscreenLoading = false;
            self.appsideList = res.data.data.records;
            // self.platformGuid = self.appsideList[0].platformGuid;
            if (res.data.data && res.data.data.records ) {
              self.selectAppSideIndex = 0;
              self.appSideGuid = res.data.data.records[0].guid;
              self.appSideList = res.data.data.records;
              self.getAllProduct();
              resolve();
              console.log(self.selectAppSideIndex);
            } else {
              self.appSideList = [];
              self.menuList = [];
              // self.menuListTable = [];
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
      });
    },
    //选中 应用端
    appSideSelect(item, index) {
      this.selectAppSideIndex = index;
      this.appSideGuid = item.guid;
      this.getAllProduct();
      if (this.productList !== null) {
        // this.getMenuListNoParent();
      }
    },
    //点击修改 应用端
    addAppSide(type, item, index) {
      if (type) {
        this.titleAppSide = '编辑';
        this.dialogAppSide = true;
        this.appSide.guid = item.guid;
        this.appSide.appSideName = item.appSideName;
        this.appSide.identifier = item.identifier;
        this.appSide.appType = item.appType;
        this.appSide.platformGuid = item.platformGuid;
        this.appside.unifiedLoginAuthUrl = item.unifiedLoginAuthUrl;
        this.selectPlatformIndex = index;
      } else {
        this.titleAppSide = '新增';
        this.appSide = {
          guid: '',
          appSideName: '',
          identifier: '',
          appType: '01',
          platformGuid: '',
          unifiedLoginAuthUrl: '',
        };
        this.dialogAppSide = true;
      }
    },
    //删除 应用端
    delAppSide(guid) {
      var self = this;
      let guids = [];
      guids.push(guid);
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api.postJson('/ms-common-admin-platform-auth-service/appside/data/delete', guids).then((res) => {
            if (res.data.code == '00000') {
              self.getAppsideData(self.platformGuid);
              self.$message.success('删除应用端成功');
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    //确定新增/修改 应用端
    submitAppSide() {
      let self = this;
      if (!self.appSide.appSideName) {
        self.$message.error('应用端不能为空！');
        return;
      }
      if (!self.appSide.identifier) {
        self.$message.error('标识符不能为空！');
        return;
      }
      if (!self.appSide.appType) {
        self.$message.error('请选择应用形式！！');
        return;
      }
      self.appSide.platformGuid = self.platformGuid;
      if (this.titleAppSide == '新增') {
        self.api.postJson('/ms-common-admin-platform-auth-service/appside/data/add', self.appSide).then((res) => {
          if (res.data.code == '00000') {
            self.getAppsideData(self.platformGuid);
            self.$message.success('新增成功');
            this.dialogAppSide = false;
          } else {
            self.$message.error(res.data.msg);
          }
        });
      } else {
        self.api.put('/ms-common-admin-platform-auth-service/appside/data/update', self.appSide).then((res) => {
          if (res.data.code == '00000') {
            self.getAppsideData(self.platformGuid);
            self.$message.success('编辑成功');
            this.dialogAppSide = false;
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }
    },
    /******************************* 产品 ************************************/
    //获取产品
    getAllProduct(appside) {
      let self = this;
      self.fullscreenLoading = true;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        platformGuid: self.platformGuid,
        appSideGuid:self.appSideGuid
      };
      return new Promise((resolve, reject) => {
        self.api.postJson('/ms-common-admin-platform-auth-service/product/data/get', query).then((res) => {
          if (res.data.code == '00000') {
            self.fullscreenLoading = false;
            if (res.data.data && res.data.data.records ) {
              self.productList = res.data.data.records;
              self.selectProductIndex = 0;
              self.productGuid = res.data.data.records[this.selectProductIndex].guid;
              self.getMenuListNoParent();
              resolve();
            } else {
              self.productList = [];
              self.menuList = [];
              self.menuListTable = [];
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
      });
    },
    //选中 产品
    productSelect(item, index) {
      this.filterText = '';
      this.selectProductIndex = index;
      this.productGuid = item.guid;
      // this.getAllProduct();
      if (this.appSideList !== null) {
        this.getMenuListNoParent();
      }
      // this.getAppsideData();
    },
    //修改 产品
    addProducts(type, item, index) {
      let self = this;
      if (type) {
        this.titleProduct = '编辑';
        this.dialogProduct = true;
        this.product.guid = item.guid;
        this.product.productName = item.productName;
        this.product.productRoute = item.productRoute;
        this.product.icon = item.icon;
        this.product.productDesc = item.productDesc;
        this.product.orderNum = item.orderNum ? Number(item.orderNum) : null;
        this.product.platformGuid = item.platformGuid;
        this.selectPlatformIndex = index;
        if (item.icon) {
          let obj = item.icon ? JSON.parse(item.icon) : {};
          let newObj = {
            name: obj.fileName,
            url: obj.path,
          };
          this.fileListIcon = [newObj];
        } else {
          let newObj = {
            name: '例图',
            url: require('../assets/example.png'),
          };
          this.fileListIcon = [newObj];
        }
      } else {
        if(!self.appSideGuid){
          self.$message.error('请先选择应用端！');
          return
        }
        this.titleProduct = '新增';
        self.product = {
          guid: '',
          productGuid: '',
          productName: '',
          productRoute: '',
          productDesc: '',
          orderNum: null,
          icon: '',
          mananger: '',
          manangerContactTel: '',
          operationParty: '',
          operationContacts: '',
          operationContactTel: '',
          upTime: '',
          platformGuid: '',
          appSideGuid:self.appSideGuid
        };
        let newObj = {
          name: '例图',
          url: require('../assets/example.png'),
        };
        this.fileListIcon = [newObj];
        this.dialogProduct = true;
      }
    },
    //删除 产品
    delProduct(guid) {
      var self = this;
      let guids = [];
      guids.push(guid);
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api.postJson(`/ms-common-admin-platform-auth-service/product/data/delete?appSideGuid=${self.appSideGuid}`, guids).then((res) => {
            if (res.data.code == '00000') {
              self.getAllProduct(self.platformGuid);
              self.$message.success('删除成功');
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    //确定新增 产品
    submitProduct() {
      var self = this;
      if (!self.product.productName) {
        self.$message.error('产品名称不能为空！');
        return;
      }
      if (this.fileListIcon.length) {
        let obj = {
          fileName: this.fileListIcon[0].name,
          path: this.fileListIcon[0].url,
        };
        self.product.icon = JSON.stringify(obj);
      }
      self.product.platformGuid = self.platformGuid;
      if (this.titleProduct == '新增') {
        self.api.postJson('/ms-common-admin-platform-auth-service/product/data/add', self.product).then((res) => {
          if (res.data.code == '00000') {
            self.getAllProduct(self.platformGuid);
            self.$message.success('保存成功');
            self.fileListIcon = [];
            self.dialogImageIcon = '';
            self.dialogProduct = false;
          } else {
            self.$message.error(res.data.msg);
          }
        });
      } else {
        self.api.put('/ms-common-admin-platform-auth-service/product/data/update', self.product).then((res) => {
          if (res.data.code == '00000') {
            self.getAllProduct(self.platformGuid);
            self.$message.success('编辑成功');
            self.dialogProduct = false;
          } else {
            self.$message.error(res.data.msg);
          }
        });
      }
    },

    /******************************* 菜单 ************************************/
    handleNodeCilck(data) {
       this.menuParentGuid = data.guid;
      this.getMenuList(data.guid);
    },
    parentChange(val) {
      if (this.ruleForm.parentGuid.length > 1) {
        this.ruleForm.parentGuid = this.ruleForm.parentGuid[this.ruleForm.parentGuid.length - 1];
      } else {
        this.ruleForm.parentGuid = this.ruleForm.parentGuid[0];
      }
      console.log(this.ruleForm.parentGuid);
    },
    getMsgData() {
      let self = this;
      let pageIndex = 1;
      let pageSize = -1;
      self.api
        .postCan('/ms-configure-service/message-group/data/get?pageIndex=' + pageIndex + '&pageSize=' + pageSize)
        .then((res) => {
          if (res.data.code == '00000') {
            self.msgList = res.data.data.records;
            // self.page.totalPage = res.data.data.totalPages;
            // self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getMenuListNoParent(flg) {
      var self = this;
      self.loading = true;
      let promise = {
        guid: '',
        menuName: self.menuName,
        parentGuid: '',
        platformGuid: self.platformGuid,
        productGuid: [self.productGuid],
      };
      self.api.postJson('/ms-common-admin-platform-auth-service/menu/data/get', promise).then((res) => {
        if (res.data.code == '00000') {
          self.loading = false;
          if (res.data.data.length) {
            self.menuList = res.data.data;
            if (flg) {
              this.$nextTick(() => {
                this.$refs.tree.setCurrentKey(this.menuParentGuid);
              });
              return;
            }
            self.getMenuList(self.menuList[0].guid);
            this.menuParentGuid =self.menuList[0].guid;
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(res.data.data[0].guid);
            });
            console.log(res.data.data[0].guid);
          } else {
            self.menuList = [];
            self.menuListTable = [];
          }

          // self.productGuid = self.productList[0].guid;
          // self.getAllMenu();
        } else {
          self.loading = false;
          self.$message.error(res.data.msg);
        }
      });
    },
    getMenuList(menuParentGuid) {
      if(!menuParentGuid) return;
      var self = this;
      let promise = {
        guid: '',
        menuName: self.menuName,
        parentGuid: menuParentGuid,
        platformGuid: self.platformGuid,
        // appSideGuid: self.appSideGuid,
        productGuid: [self.productGuid],
      };
      self.loading = true;
      self.api.postJson('/ms-common-admin-platform-auth-service/menu/data/get', promise).then((res) => {
        if (res.data.code == '00000') {
          self.loading = false;
          self.menuListTable = res.data.data;
          // self.productGuid = self.productList[0].guid;
          // self.getAllMenu();
        } else {
          self.loading = false;
          self.$message.error(res.data.msg);
        }
      });
    },
    add(flg, row) {
      let self = this;
      if (!self.appSideGuid || !self.platformGuid) {
        this.$message.error('请先添加应用端和应用产品！');
        return;
      }
      self.fileList = [];
      self.ruleForm.parentGuid = '';
      if (flg == 1) {
        self.textTitle = '新增';
        self.ruleForm = {
          parentGuid: '',
          parentName: '',
          menuName: '',
          menuType: 'C',
          orderNum: '',
          path: '',
          appletPath:'',
          icon: '',
          isExternalLink: 'N',
          bizState: 'Y',
          visible: 'Y',
          externalLinkMark: '',
          remark: '',
          messageGroupGuid: '',
          isHome: 'N',
          isNewWindow: 'N',
        };
      } else if (flg == 2) {
        self.textTitle = '编辑';
        self.ruleForm.guid = row.guid;
        self.ruleForm.parentGuid = row.parentGuid;
        self.ruleForm.parentName = row.parentName;
        self.ruleForm.menuName = row.menuName;
        self.ruleForm.menuType = row.menuType;
        self.ruleForm.orderNum = row.orderNum;
        self.ruleForm.path = row.path;
        self.ruleForm.appletPath = row.appletPath;
        self.ruleForm.icon = row.icon;
        self.ruleForm.isExternalLink = row.isExternalLink;
        self.ruleForm.bizState = row.bizState;
        self.ruleForm.visible = row.visible;
        self.ruleForm.externalLinkMark = row.externalLinkMark;
        self.ruleForm.platformGuid = row.platformGuid;
        self.ruleForm.productGuid = row.productGuid;
        self.ruleForm.isNewWindow = row.isNewWindow;
        // self.ruleForm.appSideGuid = row.appSideGuid;
        self.ruleForm.remark = row.remark;
        self.ruleForm.isHome = row.isHome;
        self.ruleForm.messageGroupGuid = row.messageGroupGuid;
        if (row.icon) {
          let item = {
            name: 'icon',
            url: row.icon,
          };
          self.fileList.push(item);
        }
      } else {
        self.textTitle = '添加子菜单';
        self.fileList = [];
        self.ruleForm.guid = row.guid;
        self.ruleForm.parentGuid = row.guid;
        self.ruleForm.parentName = row.parentName;
        self.ruleForm.menuName = '';
        self.ruleForm.menuType = 'C';
        self.ruleForm.orderNum = '';
        self.ruleForm.path = '';
        self.ruleForm.appletPath = '';        
        self.ruleForm.icon = '';
        self.ruleForm.isExternalLink = 'N';
        self.ruleForm.bizState = 'Y';
        self.ruleForm.visible = 'Y';
        self.ruleForm.isNewWindow = 'N';
        self.ruleForm.externalLinkMark = '';
        self.ruleForm.platformGuid = row.platformGuid;
        self.ruleForm.productGuid = row.productGuid;
        self.ruleForm.isHome = row.isHome;
        // self.ruleForm.appSideGuid = row.appSideGuid;
        self.ruleForm.remark = '';
        self.ruleForm.messageGroupGuid = '';
        if (row.icon) {
          let item = {
            name: 'icon',
            url: row.icon,
          };
          self.fileList.push(item);
        }
      }
      this.dialogFormVisible = true;
    },
    submitForm(formName) {
      let self = this;
      if (!self.ruleForm.menuName) {
        this.$message.error('请输入菜单名称！');
        return;
      }
      if (!self.ruleForm.orderNum) {
        this.$message.error('请输入菜单排序！');
        return;
      }
      // self.$refs[formName].validate((valid) => {
      //   if (valid) {
      let promise = {
        parentGuid: self.ruleForm.parentGuid,
        menuName: self.ruleForm.menuName,
        platformGuid: self.platformGuid,
        // appSideGuid: self.appSideGuid,
        productGuid: self.productGuid,
        path: self.ruleForm.path,
        appletPath:self.ruleForm.appletPath,
        icon: self.ruleForm.icon,
        orderNum: self.ruleForm.orderNum,
        menuType: self.ruleForm.menuType,
        visible: self.ruleForm.visible,
        bizState: self.ruleForm.bizState,
        isExternalLink: self.ruleForm.isExternalLink,
        externalLinkMark: self.ruleForm.externalLinkMark,
        remark: self.ruleForm.remark,
        messageGroupGuid: self.ruleForm.messageGroupGuid,
        isHome: self.ruleForm.isHome,
        isNewWindow: self.ruleForm.isNewWindow,
      };
      self.api.postJson('/ms-common-admin-platform-auth-service/menu/data/add', promise).then((res) => {
        if (res.data.code == '00000') {
          self.dialogFormVisible = false;
          self.$message.success('添加成功');
          self.getMenuList(self.menuParentGuid);
          self.getMenuListNoParent(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
      // } else {
      //   console.log('error submit!!');
      //   return false;
      // }
      // });
    },
    upDateForm(formName) {
      let self = this;
      if (!self.ruleForm.menuName) {
        this.$message.error('请输入菜单名称！');
        return;
      }
      if (!self.ruleForm.orderNum) {
        this.$message.error('请输入菜单排序！');
        return;
      }
      // self.$refs[formName].validate((valid) => {
      //   if (valid) {
      //     let par = '';
      //     if (self.ruleForm.parentGuid) {
      //       par = self.ruleForm.parentGuid;
      //     } else {
      //       par = '';
      //     }
      console.log(self.ruleForm.parentGuid);
      let promise = {
        guid: self.ruleForm.guid,
        parentGuid: self.ruleForm.parentGuid,
        menuName: self.ruleForm.menuName,
        platformGuid: self.platformGuid,
        // appSideGuid: self.appSideGuid,
        productGuid: self.productGuid,
        path: self.ruleForm.path,
        appletPath:self.ruleForm.appletPath,
        icon: self.ruleForm.icon,
        orderNum: self.ruleForm.orderNum,
        menuType: self.ruleForm.menuType,
        visible: self.ruleForm.visible,
        bizState: self.ruleForm.bizState,
        isExternalLink: self.ruleForm.isExternalLink,
        externalLinkMark: self.ruleForm.externalLinkMark,
        remark: self.ruleForm.remark,
        messageGroupGuid: self.ruleForm.messageGroupGuid,
        isHome: self.ruleForm.isHome,
        isNewWindow: self.ruleForm.isNewWindow,
      };
      console.log(promise);
      self.api.put('/ms-common-admin-platform-auth-service/menu/data/update', promise).then((res) => {
        if (res.data.code == '00000') {
          self.dialogFormVisible = false;
          self.$message.success('编辑成功');
          self.getMenuList(this.menuParentGuid)
          self.getMenuListNoParent(true);
        } else {
          self.$message.error(res.data.msg);
        }
      });
      //   } else {
      //     console.log('error submit!!');
      //     return false;
      //   }
      // });
    },
    getDeleteData(guid) {
      let self = this;
      self.multipleSelection = [];
      self.multipleSelection.push(guid);
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson('/ms-common-admin-platform-auth-service/menu/data/delete', self.multipleSelection)
            .then((res) => {
              if (res.data.code == '00000') {
                self.multipleSelection = [];
                self.$message.success('删除成功');
                self.getMenuList(this.menuParentGuid)
                self.getMenuListNoParent(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    //产品图标上传
    uploadImageIcon(file) {
      let self = this;
      console.log('?????', file.file);
      self.fileListIcon = [];
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.url, formData)
        .then((res) => {
          if (res.data.code == '00000') {
            // self.ruleForm.platformLogo = res.data.data;
            let item = {
              name: file.file.name,
              url: res.data.data,
            };
            self.fileListIcon.push(item);
            // self.ruleForm.icon = res.data.data;
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleRemoveIcon(file) {
      let self = this;
      self.ruleForm.icon = '';
      self.iconSh = false;
      self.fileListIcon = [];
    },
    handlePictureCardPreviewIcon(file) {
      this.dialogImageIcon = file.url;
      this.dialogVisibleIcon = true;
    },
    handleDownloadIcon(file) {
      console.log(file);
    },
    //产品背景图片上传
    uploadImageBack(file) {
      let self = this;
      console.log(file.file);
      self.fileListBack = [];
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.url, formData)
        .then((res) => {
          if (res.data.code == '00000') {
            self.ruleForm.platformLogo = res.data.data;
            let item = {
              name: 'icon',
              url: res.data.data,
            };
            self.fileListBack.push(item);
            self.ruleForm.icon = res.data.data;
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleRemoveBack(file) {
      let self = this;
      self.ruleForm.icon = '';
      self.iconSh = false;
      self.fileListIcon = [];
    },
    handlePictureCardPreviewBack(file) {
      this.dialogImageBack = file.url;
      this.dialogVisibleBack = true;
    },
    handleDownloadBack(file) {
      console.log(file);
    },

    uploadImage(file) {
      let self = this;
      console.log(file.file);
      self.fileList = [];
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.url, formData)
        .then((res) => {
          if (res.data.code == '00000') {
            self.ruleForm.platformLogo = res.data.data;
            let item = {
              name: 'icon',
              url: res.data.data,
            };
            self.fileList.push(item);
            self.ruleForm.icon = res.data.data;
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
    handleRemove(file) {
      let self = this;
      self.ruleForm.icon = '';
      self.iconSh = false;
      self.fileList = [];
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl1 = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    //获取图标数据
    getIconList() {
      let self = this;
      let req = {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        bizType: '图标管理',
        paramName: '',
      };
      self.api.postJson(`/ms-sales-perform-service/biz-param/data/get-list`, req).then((res) => {
        self.fullscreenLoading = false;
        if (res.data.code == '00000') {
          self.iconList = res.data.data.records;
          self.activeIcon = 0;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleClickMenu(index) {
      this.activeIcon = index;
    },
    chooseIcon(url) {
      this.chooseURL = url;
    },
    delPic(type) {
      if (type == 0) {
        this.fileListIcon = [];
      } else {
        this.fileList = [];
      }
      this.$forceUpdate();
    },
    addPic(type) {
      if (type == 0) {
        if (this.fileListIcon.length != 0) {
          this.$message.error('应用图标只能选择一个');
          return;
        }
        this.type = 0;
        this.chooseURL = '';
        this.iconVisible = true;
      } else {
        if (this.fileList.length != 0) {
          this.$message.error('图标只能选择一个');
          return;
        }
        this.type = 1;
        this.chooseURL = '';
        this.iconVisible = true;
      }
    },
    moreSureIcon(type) {
      if (this.type == 0 && this.chooseURL) {
        this.fileListIcon = [
          {
            name: '应用图标',
            url: this.chooseURL,
          },
        ];
      }
      if (this.type == 1 && this.chooseURL) {
        this.fileList = [
          {
            name: '图标',
            url: this.chooseURL,
          },
        ];
        this.ruleForm.icon = this.chooseURL;
      }
      this.iconVisible = false;
      this.$forceUpdate();
    },
  },
};
</script>
